import script from "./arr.vue?vue&type=script&setup=true&lang=js"
export * from "./arr.vue?vue&type=script&setup=true&lang=js"

import "./arr.vue?vue&type=style&index=0&id=0598ed02&scoped=true&lang=scss"

import exportComponent from "/Users/vadimkholodov/Documents/GitHub/vahta-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0598ed02"]])

export default __exports__